import { IDictionary } from '@bimser/core';
import { PrimitiveType } from './Types';

export type IPropertyFieldType =
	| 'string'
	| 'number'
	| 'date'
	| 'time'
	| 'boolean'
	| 'object'
	| 'enum'
	| 'array'
	| 'any';

export interface IPropertyField {
	name: string;
	type: IPropertyFieldType;
	items?: IPropertyField[];
	enumMembers?: string[];
	readOnly?: boolean;
	hiddenOn?: Array<'rule-manager' | 'formula-manager' | 'data-synchronizer'>;
	options?: IDictionary<any>;
	common?: boolean;
	isArray?: boolean;
}

export function convertTypeToFieldType(primitiveType: PrimitiveType): IPropertyFieldType {
	switch (primitiveType) {
		case 'boolean':
			return 'boolean';
		case 'date':
			return 'date';
		case 'decimal':
		case 'integer':
			return 'number';
		case 'string':
		default:
			return 'string';
	}
}
